import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Layout } from 'react-admin';
import { useTheme } from '@mui/material/styles';

import MenuCustom from './MenuCustom';
import AppBar from './AppBarCustom';

const LayoutCustom = ({ children }) => {
    const theme = useTheme();

    useEffect(() => {
        if (theme.palette.mode === 'dark') {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }, [theme.palette.mode]);

    return (
        <Layout
            appBar={AppBar}
            menu={MenuCustom}
        >
            {children}
        </Layout>
    );
};

LayoutCustom.propTypes = {
    children: PropTypes.node,
};

export default LayoutCustom;
